module.exports = __webpack_public_path__ + "img/EnracineScreenshot1_996x703.4b520776.png";